import BaseAPI from '@/apis/base'
import { apis, getApiUrl } from '../api-config'

class SubjectAPI extends BaseAPI {}

export default new SubjectAPI('v1/subjects', 'Subject', getApiUrl(apis.CommonAPI))
